var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 29,
    viewBox: "0 0 35 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.8125,
    width: 35,
    height: 28,
    fill: "url(#pattern0_10636_4674)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_10636_4674",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_10636_4674",
    transform: "matrix(0.00888889 0 0 0.0111111 0.1 0)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_10636_4674",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAAAXNSR0IArs4c6QAABDZJREFUeF7t3L9PFEEUB/DvcHcBokZjtFF7TTDaaextUCDskmuosBATEzVa+KNQE6OJFiYabbTV0FzcJUTDv6CdRP8EfyRgAYjxhF3GLBGC5PZ2ZmduWI6vre/tm/ncu3d7e8sK8J8TAeGkCouA0I6agNCEdiTgqAw7mtCOBByVYUcT2pGAozLsaEI7EnBUhh1dFOiRkZGun7OzF6QQwxCiB1LucLS2YpcR4heAz1LKsXq9/mJycvJPswU37Wjf9w9ByncAjhV715u+uikI0RcEwZe0laRCJ508Pzf3gcjKL+LU73r9ZFpnp0IPDQ5ekUI8US7DQECIy0EQPGtEkQrte17SzSfopyXwPgjDU7rQPwHs1CrD4IUgDHfpQstGCUEYZp4S+p7XMHervA4me0zLbTY6CN2kM9KaidAabyd2tAaWSSihTfQ0cgmtgWUSSmgTPY1cQmtgmYQS2kRPI7cQ0Brr3Zah1s6jt6WexqYJrYFlElp06EVIeTtaXn7d2dm5FC8tnYMQtwDsMdn0ZuQWGloCN8MwfLQeplqt7l+OonsSOA+gtBloeWoWGhpCHAiC4HujjQ0NDR2RcfwYQpzJs3HXOdagTU590jatdEzfPw0pk198elqNp7SelEvBWx46wR0dHa38mJ5O5vcDAPtaBb7toVdhq9Xq3uUouiuBiwDKtsEJvUG0VfOb0Cmt61ue34RuMiNszm9CKwxjG/Ob0ArQax+YAwOH41LpMYCzGmkroYTWFQOQZ34XAjrHXjNTVDaWeZDs+X0VQtwHUDE5VlautS8sWYXy/H+roVfX5A8OXocQ/11TybPeZjmEBtDf37+vUi7P2MZdfzxCA0iuCMZRNE3oVgoA8DzvhgAetrLMtu7o5MvMzMzMNQEkH4bWr420ZHSofHDp3k2qcsy8XbhlT+9UUIoAbXLByWSP1kaHySLSulLlmKodza/gTaRsQPOikkIrmkLnmcN5vnSsz9mSN6LnhTaZw4RWeAfYmMOEzr44xB9n1y7eaP5VlsrosD2HC9/RCu9s7ZAojg9OTEx8a5TYqjmsvUjFBGvn0Yr1tMJ4S5gWl1HwogTuxHH8qlQqRULKEd7kaOTZ/smFHh3txE9oR6+mNWilUzHN0ztHBsplTPZIaGXmNr6vQ8PASSg72gkzO9oRM6EJvVFA9zdDZ4KKhTijFaFMwwhtKqiY7xqaj2NTfGFWwyQwH4bh7kZpfMCgJmZGuP4DBj3PuyyAp3bX0d5HE1JeejM+/lyro3t7ezu7u7qSx2Yeb28eO7sTwMeOcvlkrVZb1IJOgv891vgtsZu/GP+Q+2q12te0yMzHX650dnf3KKQcBnCUzytdo1wA8ElIOdZRqbxM6+TV6ExoO28sHoXQjnqA0IR2JOCoDDua0I4EHJVhRxPakYCjMuxoQjsScFSGHU1oRwKOyvwFwVE0iMttenAAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.d5c59aad2d2e11e0693133b83e1e48fc.svg";
export { ForwardRef as ReactComponent };